<template>
  <div class="main">
    <home-about />
    <home-service />
    <home-feature />
  </div>
</template>

<script>
import HomeAbout from './mainPage/HomeAbout.vue'
import HomeFeature from './mainPage/HomeFeature.vue'
import HomeService from './mainPage/HomeService.vue'

export default {
  components: {
    HomeAbout,
    HomeService,
    HomeFeature,
  },
  directives: {
    // Ripple,
  },
  props: {},
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },

  setup() {
  },
}
</script>
<style lang="scss" scoped>
.main{
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
